import { ConfigurationsObjectsType } from "components/ui/ConfigurationsObjectsType/ConfigurationsObjectsType"
import { Tooltip } from "../tooltip/Tooltip"
import { TObjectsType } from "types/configuration.type"
import { objectTypeTextTooltip } from "helpers/utils.helper"

type Props = { type: TObjectsType }

export const ObjectTypeTooltip = ({ type }: Props) => {
	return (
		<Tooltip text={objectTypeTextTooltip(type)} placement="bottom">
			<div style={{ width: "fit-content" }} data-testid="objectType">
				<ConfigurationsObjectsType type={type} />
			</div>
		</Tooltip>
	)
}
